var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:('这是是动态'),expression:"'这是是动态'"}],staticClass:"container"},[_c('Tabs',{attrs:{"data":_vm.tabs}}),_c('Map')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }